/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as actiontypes from './actionTypes';

const initialstate = {
  active_tab: 'one',
  create_err_msg: [],
  create_fld_err: {},
  create_pgm_detail: {},
  cr_default_audit: false,
  cr_save_disable: true,
  create_ura_grid_data: {
    rpcUrPayment: [],
    rpcUraCal: [],
    rpcUraSource: [],
  },
  cr_deleted_ura_src: [],
  cr_deleted_ura_calc: [],
  cr_deleted_ura_pay: [],
  cr_int_grid_data: {
    rpcParamVoIntShareIntCalList: [],
    rpcCalcPctVOIntShareFedaralList: [],
    rpcParamVoIntShareFedaralFamiliList: [],
  },
  cr_deleted_int_calc: [],
  cr_deleted_int_fed: [],
  cr_deleted_int_fed_fmly: [],
  cr_group_data: {
    cmsReporting: [],
    cmsUtilization: [],
  },
  cr_deleted_cms_rpt: [],
  cr_deleted_cms_util: [],

  cr_deleted_enroll: [],
  cr_enroll_data: [],

  cr_audit_data: {
    CAEStestOnInd: 0,
    CAEStestAmt: null,
    CIDCtestOnInd: 0,
    CREStestOnInd: 0,
    CRLAtestOnInd: 0,
    CRLAtestAmt: null,
    CSRAtestOnInd: 0,
    CSRAtestAmt: null,
    CSTRtestOnInd: 0,
    CSTRtestAmt: null,
    CUNAtestOnInd: 0,
    CUNAtestAmt: null,
    IRGLtestOnInd: 0,
    IRGLtestPct: null,
    IRGPtestOnInd: 0,
    IRGPtestPct: null,
    IRGRtestOnInd: 0,
    IRGRtestPct: null,
    IUNPtestOnInd: 0,
    IUNPtestPct: null,
  },
  cr_unit_type_data: [
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'AHF',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Anti-Hemophilic Factor units',
      codeValue: 'AHF',
      longDescription:
        'Refers only to injectable Anti-Hemophilic Factor (AHF) units.',
    },
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'CAP',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Capsule',
      codeValue: 'CAP',
      longDescription: 'Capsule',
    },
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'EA',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Each',
      codeValue: 'EA',
      longDescription: 'Each (drugs not identifiable by any other unit type)',
    },
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'GM',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Gram',
      codeValue: 'GM',
      longDescription: 'Gram',
    },
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'ML',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Milliliter',
      codeValue: 'ML',
      longDescription: 'Milliliter',
    },
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'SUP',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Suppository',
      codeValue: 'SUP',
      longDescription: 'Suppository',
    },
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'TAB',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Tablet',
      codeValue: 'TAB',
      longDescription: 'Tablet',
    },
    {
      testGroupCd: 'C',
      testTypeCd: 'UNT',
      testUnitTypeCd: 'TDP',
      testOnInd: 0,
      testPct: null,
      testAmt: null,
      mailOrderMultiplier: null,
      shortDescription: 'Transdermal Patch',
      codeValue: 'TDP',
      longDescription: 'Transdermal patch',
    },
  ],
  created_flag: false,
  cr_max_enroll_qtr: null,
  CR_last_frozen_qtr: null,
  CR_last_ura_src_calc_qtr: null,
  cr_cms_freeze_qtr: null,
  copy_create_pgm_detail: {},
  cr_copy_unit_type_data: [],
  create_copy_ura_grid_data: {},
  cr_copy_int_data: {},
  cr_copy_enroll_data: [],
  cr_copy_group_data: {},
  cr_copy_audit_data: {},
};

const reducer = (state = initialstate, action) => {
  switch (action.type) {
    case actiontypes.CREATED_FLAG:
      return { ...state, created_flag: action.payload };
    case actiontypes.CLEAR_CREATE_RBT_REDUX:
      return initialstate;
    case actiontypes.TAB:
      return { ...state, active_tab: action.payload };
    case actiontypes.CREATE_REBATE_ERROR_MSG:
      return { ...state, create_err_msg: action.payload };
    case actiontypes.CREATE_FIELD_ERR:
      return { ...state, create_fld_err: action.payload };
    case actiontypes.CREATE_REBATE_PGM_DETAIL:
      return { ...state, create_pgm_detail: action.payload };
    case actiontypes.COPY_CREATE_REBATE_PGM_DETAIL:
      return { ...state, copy_create_pgm_detail: action.payload };
    case actiontypes.CR_DEFAULT_AUDIT:
      return { ...state, cr_default_audit: action.payload };
    case actiontypes.CR_ENABLE_SAVE:
      return { ...state, cr_save_disable: action.payload };
    case actiontypes.CR_COMMENTS_FLAG:
      return { ...state, cr_comment_flag: action.payload };
    case actiontypes.COPY_DATA:
      return { ...state, copy_data: action.payload };

    case actiontypes.CR_URA_GRID_DATA:
      return { ...state, create_ura_grid_data: action.payload };
    case actiontypes.CR_DELETED_URA_SOURCE:
      return { ...state, cr_deleted_ura_src: action.payload };
    case actiontypes.CR_DELETED_URA_CALC:
      return { ...state, cr_deleted_ura_calc: action.payload };
    case actiontypes.CR_DELETED_URA_PAY:
      return { ...state, cr_deleted_ura_pay: action.payload };
    case actiontypes.CR_LAST_FROZEN_QTR:
      return { ...state, CR_last_frozen_qtr: action.payload };
    case actiontypes.CR_LAST_URA_SRC_CALC_QTR:
      return { ...state, CR_last_ura_src_calc_qtr: action.payload };

    case actiontypes.CR_COPY_URA_GRID_DATA:
      return { ...state, create_copy_ura_grid_data: action.payload };
    default:
      return state;

    case actiontypes.CR_INT_GRID_DATA:
      return { ...state, cr_int_grid_data: action.payload };
    case actiontypes.CR_COPY_INT_GRID_DATA:
      return { ...state, cr_copy_int_data: action.payload };
    case actiontypes.CR_DELETED_INT_CALC:
      return { ...state, cr_deleted_int_calc: action.payload };
    case actiontypes.CR_DELETED_INT_FED:
      return { ...state, cr_deleted_int_fed: action.payload };
    case actiontypes.CR_DELETED_INT_FED_FMLY:
      return { ...state, cr_deleted_int_fed_fmly: action.payload };

    case actiontypes.CR_GROUP_GRID_DATA:
      return { ...state, cr_group_data: action.payload };
    case actiontypes.CR_COPY_GROUP_GRID_DATA:
      return { ...state, cr_copy_group_data: action.payload };
    case actiontypes.CR_DELETED_CMS_RPT:
      return { ...state, cr_deleted_cms_rpt: action.payload };
    case actiontypes.CR_DELETED_CMS_UTIL:
      return { ...state, cr_deleted_cms_util: action.payload };
    case actiontypes.CR_CMS_FREEZE_QTR:
      return { ...state, cr_cms_freeze_qtr: action.payload };

    case actiontypes.CR_ENROLL_GRID_DATA:
      return { ...state, cr_enroll_data: action.payload };
    case actiontypes.CR_COPY_ENROLL_GRID_DATA:
      return { ...state, cr_copy_enroll_data: action.payload };
    case actiontypes.CR_MAX_ENROLL_QTR:
      return { ...state, cr_max_enroll_qtr: action.payload };
    case actiontypes.CR_DELETED_ENROLL:
      return { ...state, cr_deleted_enroll: action.payload };

    case actiontypes.CR_COPY_AUDIT_GRID_DATA:
      return { ...state, cr_copy_audit_data: action.payload };
    case actiontypes.CR_CONS_AUDIT_DATA:
      return { ...state, cr_audit_data: action.payload };

    case actiontypes.CR_COPY_UNIT_TYPE_DATA:
      return { ...state, cr_copy_unit_type_data: action.payload };
    case actiontypes.CR_UNIT_TYPE_AUDIT_GRID_DATA:
      return { ...state, cr_unit_type_data: action.payload };

    case actiontypes.CR_USE_DEF_AUDIT:
      return { ...state, cr_use_def_audit: action.payload };

    // case actiontypes.RESET_CREATE_PGM:
    //   return { ...state, ...JSON.parse(JSON.stringify(initialstate)) };

    case actiontypes.RESET_CREATE_PGM:
      return initialstate;

    case actiontypes.CUSTOME_RESET_CREATE_PGM:
      return { ...JSON.parse(JSON.stringify(initialstate)), ...action.payload };

    case actiontypes.CR_DEFAULT_OVERRIDE_DATA:
      return { ...state, cr_def_override: action.payload };

    case actiontypes.IS_VALID_REBETE_PGM:
      return { ...state, is_valid_rebate_pgm: action.payload };

    case actiontypes.CR_AUDIT_GRID_DATA:
      return { ...state, cr_audit_grid_data: action.payload };
  }
};

export default reducer;
